export default "__VITE_ASSET__b836e273__"